//路由相关配置
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  // 客户端
  {
    path: '/',
    name: 'layout',
    component: () => import("@/views/layout/index.vue"),
    redirect: "/index",
    children: [
      // 首页
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/home/index.vue"),
        meta: {
          keepAlive: false,
        },
      },
      // 二级页面
      {
        path: "/study",
        name: 'study',
        component: () => import("@/views/layout/study.vue"),
        redirect: "/courseCenter",
        children: [
          // 更多信息
          {
            path: '/information',
            name: 'information',
            component: () => import("@/views/home/information/index.vue"),
          },
          // 招贤纳士
          {
            path: '/recruit',
            name: 'recruit',
            component: () => import("@/views/home/recruit/index.vue"),
            meta: {
              activeMenu: 'recruit',
              keepAlive: false,
            },
          },
          // 课程中心
          {
            path: "/courseCenter",
            name: "courseCenter",
            component: () => import("@/views/home/courseList/index.vue"),
            meta: {
              activeMenu: 'course',
              keepAlive: false,
            },
          },
          // 课程详情
          {
            path: '/courseInf/:course_id',
            name: 'courseInf',
            component: () => import("@/views/home/courseInf/index.vue"),
            meta: {
              activeMenu: 'course',
              keepAlive: false,
            },
          },
          // 课程购买
          {
            path: '/courseBuy/:course_id',
            name: 'courseBuy',
            component: () => import("@/views/home/courseBuy/index.vue"),
            meta: {
              activeMenu: 'course',
              keepAlive: false,
            },
          },
          // 题库
          {
            path: "/questionBank",
            name: "questionBank",
            component: () => import("@/views/home/questionBank/index.vue"),
            meta: {
              activeMenu: 'questionBank',
              keepAlive: false,
            },
          },
          // 题库购买
          {
            path: '/questionBankBuy/:QL_Id',
            name: 'questionBankBuy',
            component: () => import("@/views/home/questionBankBuy/index.vue"),
            meta: {
              activeMenu: 'questionBank',
              keepAlive: false,
            },
          },
          // 题库详情
          {
            path: '/questionBankInf/:QL_Id',
            name: 'questionBankInf',
            component: () => import("@/views/home/questionBankInf/index.vue"),
            meta: {
              activeMenu: 'questionBank',
              keepAlive: false,
            },
          },
          // 素材库
          {
            path: "/dataBank",
            name: "dataBank",
            component: () => import("@/views/home/dataBank/index.vue"),
            meta: {
              activeMenu: 'dataBank',
              keepAlive: false,
            },
          },
          // 素材购买
          {
            path: '/dataBankBuy/:smlibId',
            name: 'dataBankBuy',
            component: () => import("@/views/home/dataBankBuy/index.vue"),
            meta: {
              activeMenu: 'dataBank',
              keepAlive: false,
            },
          },
          // 素材详情
          {
            path: '/dataBankInf/:smlibId',
            name: 'dataBankInf',
            component: () => import("@/views/home/dataBankInf/index.vue"),
            meta: {
              activeMenu: 'dataBank',
              keepAlive: false,
            },
          },
          // 软件
          {
            path: "/softWare",
            name: "softWare",
            component: () => import("@/views/home/softWare/index.vue"),
            meta: {
              activeMenu: 'softWare',
              keepAlive: false,
            },
          },
          // 软件购买
          {
            path: '/softWareBuy/:softwareId',
            name: 'softWareBuy',
            component: () => import("@/views/home/softWareBuy/index.vue"),
            meta: {
              activeMenu: 'softWare',
              keepAlive: false,
            },
          },
          // 软件详情
          {
            path: '/softWareInf/:softwareId',
            name: 'softWareInf',
            component: () => import("@/views/home/softWareInf/index.vue"),
            meta: {
              activeMenu: 'softWare',
              keepAlive: false,
            },
          },
          // 服务条款
          {
            path: "/termsService",
            name: "termsService",
            component: () => import("@/views/home/termsService/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 企业入驻
          {
            path: "/enterprise",
            name: "enterprise",
            component: () => import("@/views/home/enterprise/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 机构入住
          {
            path: "/mechanism",
            name: "mechanism",
            component: () => import("@/views/home/mechanism/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 师资入驻
          {
            path: "/teachers",
            name: "teachers",
            component: () => import("@/views/home/teachers/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 申请加入企业
          {
            path: '/joinEnterprise',
            name: 'joinEnterprise',
            component: () => import("@/views/home/joinEnterprise/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 个人中心
          {
            path: "/personal",
            name: "personal",
            component: () => import("@/views/home/personal/index.vue"),
            meta: {
              keepAlive: false,
            },
            redirect: "/myData",
            children: [
              {
                // 我的数据
                path: "/myData",
                name: "myData",
                component: () => import("@/views/home/personal/components/myData.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 我的课程
                path: "/myCourse",
                name: "myCourse",
                component: () => import("@/views/home/personal/components/myCourse.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 我的题库
                path: "/myBank",
                name: "myBank",
                component: () => import("@/views/home/personal/components/myBank.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 我的素材
                path: "/myMaterial",
                name: "myMaterial",
                component: () => import("@/views/home/personal/components/myMaterial.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 课程计划
                path: "/plan",
                name: "plan",
                component: () => import("@/views/home/personal/components/plan.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 培训档案
                path: "/files",
                name: "files",
                component: () => import("@/views/home/personal/components/files.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 培训证书
                path: "/certificate",
                name: "certificate",
                component: () => import("@/views/home/personal/components/certificate.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 个人信息
                path: "/userInf",
                name: "userInf",
                component: () => import("@/views/home/personal/components/userInf.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 我的收藏
                path: "/collections",
                name: "collections",
                component: () => import("@/views/home/personal/components/collections.vue"),
                meta: {
                  keepAlive: false,
                },
                children:[
                  {
                    path: "/collectOne",
                    name: "collectOne",
                    component: () => import("@/views/home/personal/components/collentionDemo/collectOne"),
                    meta: {
                      keepAlive: false,
                    },
                  },
                  {
                    path: "/collectTwo",
                    name: "collectTwo",
                    component: () => import("@/views/home/personal/components/collentionDemo/collectTwo.vue"),
                    meta: {
                      keepAlive: false,
                    },
                  },
                  {
                    path: "/collectThree",
                    name: "collectThree",
                    component: () => import("@/views/home/personal/components/collentionDemo/collectThree.vue"),
                    meta: {
                      keepAlive: false,
                    },
                  },

                ]
              },
              {
                // 我的积分
                path: "/myPoints",
                name: "myPoints",
                component: () => import("@/views/home/personal/components/myPoints.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 错题记录
                path: "/wrongRecord",
                name: "wrongRecord",
                component: () => import("@/views/home/personal/components/wrongRecord.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 我的订单
                path: "/order",
                name: "order",
                component: () => import("@/views/home/personal/components/order.vue"),
                meta: {
                  keepAlive: false,
                },
              },
              {
                // 网上答疑
                path: "/question",
                name: "question",
                component: () => import("@/views/home/personal/components/question.vue"),
                meta: {
                  keepAlive: false,
                },

              }
            ]
          },
          // 每日一练
          {
            path: "/dailyTrain",
            name: "dailyTrain",
            component: () => import("@/views/home/dailyTrain/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每日一练历史记录
          {
            path: "/dailyHistory",
            name: "dailyHistory",
            component: () => import("@/views/home/dailyHistory/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每日一练查看详情
          {
            path: "/dailyDetail/:id",
            name: "dailyDetail",
            component: () => import("@/views/home/dailyDetail/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每周一课
          {
            path: "/weekClass",
            name: "weekClass",
            component: () => import("@/views/home/weekClass/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每月一考
          {
            path: "/monthExam",
            name: "monthExam",
            component: () => import("@/views/home/monthExam/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每日一练历史记录
          {
            path: "/monthHistory",
            name: "monthHistory",
            component: () => import("@/views/home/monthHistory/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
          // 每月一考查看详情
          {
            path: "/montDetail/:id",
            name: "montDetail",
            component: () => import("@/views/home/montDetail/index.vue"),
            meta: {
              keepAlive: false,
            },
          },
        ]
      },
      // 计划试卷-模拟、考试
      {
        path: "/planexampaper/:planId/:paperClassify",
        name: "planexampaper",
        component: () => import("@/views/home/planexampaper/index.vue"),
        meta: {
          keepAlive: false,
        },
      },
      // 计划试卷-练习
      {
        path: "/planplanpracticempaper/:planId",
        name: "planplanpracticempaper",
        component: () => import("@/views/home/planexampaper/planpracticempaper.vue"),
        meta: {
          keepAlive: false,
        },
      },
      // 试卷-模拟、考试
      {
        path: "/exampaper/:ownPaperId",
        name: "exampaper",
        component: () => import("@/views/home/exampaper/index.vue"),
        meta: {
          keepAlive: false,
        },
      },
      // 试卷-练习
      {
        path: "/planpracticempaper/:ownPaperId",
        name: "planpracticempaper",
        component: () => import("@/views/home/exampaper/planpracticempaper.vue"),
        meta: {
          keepAlive: false,
        },
      },
      // 题库练习
      {
        path: "/practicempaper/:ownQuestionBankId/:questionBankId",
        name: "practicempaper",
        component: () => import("@/views/home/practicempaper/index.vue"),
        meta: {
          keepAlive: false,
        },
      }
    ]
  },
  // 跳转视频界面
  {
    path: "/watchvideo/:course_id/:Ch_Id",
    name: "watchvideo",
    component: () => import("@/views/home/watchvideo/index.vue"),
    meta: {
      keepAlive: false,
    },
    children: [
      // Video
      {
        path: "/videoIndex",
        name: "videoIndex",
        component: () => import("@/views/home/watchvideo/components/videoIndex.vue"),
        meta: {
          keepAlive: false,
        }
      },
    ]

  },
  // 管理端
  {
    path: '/admin',
    name: 'admin',
    component: () => import("@/views/admin/adminHeaderLayout/index.vue"),
    redirect: "/admin/bigData",
    children: [
      // 平台大数据
      {
        path: "/admin/home",
        name: "adminHome",
        component: () => import("@/views/admin/adminBigData/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminHome',
          hidden: false,
          name: '平台大数据'
        },
        redirect: "/admin/bigData",
        children: [
          // 平台数据
          {
            path: "/admin/bigData",
            name: "adminBigData",
            component: () => import("@/views/admin/adminBigData/bigData.vue"),
            meta: {
              name: '平台数据',
              keepAlive: true,
              activeMenu: '/admin/bigData',
              hidden: false,
            },
          },
        ]
      },
      // 平台运维
      {
        path: "/admin/operation",
        name: "adminOperation",
        component: () => import("@/views/admin/adminOperation/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'operation',
          hidden: false,
          name: '平台运维'
        },
        redirect: "/admin/pageMaintenance",
        children: [
          // 接口管理
          {
            path: "/admin/apiMaintenance",
            name: "apiMaintenance",
            component: () => import("@/views/admin/adminOperation/apiMaintenance/index.vue"),
            meta: {
              name: '接口管理',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 菜单管理
          {
            path: "/admin/pageMaintenance",
            name: "pageMaintenance",
            component: () => import("@/views/admin/adminOperation/pageMaintenance/index.vue"),
            meta: {
              name: '菜单管理',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 角色管理
          {
            path: "/admin/roleManage",
            name: "roleManage",
            component: () => import("@/views/admin/adminOperation/roleManage/index.vue"),
            meta: {
              name: '角色管理',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 权限配置
          {
            path: "/admin/permissionConfiguration",
            name: "permissionConfiguration",
            component: () => import("@/views/admin/adminOperation/permissionConfiguration/index.vue"),
            meta: {
              name: '权限配置',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 管理员管理
          {
            path: "/admin/administratorManagement",
            name: "administratorManagement",
            component: () => import("@/views/admin/adminOperation/administratorManagement/index.vue"),
            meta: {
              name: '管理员管理',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 敏感词
          {
            path: "/admin/sensitiveWords",
            name: "sensitiveWords",
            component: () => import("@/views/admin/adminOperation/sensitiveWords/index.vue"),
            meta: {
              name: '敏感词',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 在线用户
          {
            path: "/admin/onlineUser",
            name: "onlineUser",
            component: () => import("@/views/admin/adminOperation/onlineUser/index.vue"),
            meta: {
              name: '在线用户',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 内容审核
          {
            path: "/admin/contentReview",
            name: "contentReview",
            component: () => import("@/views/admin/adminOperation/contentReview/index.vue"),
            meta: {
              name: '内容审核',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 发言功能设置
          {
            path: "/admin/speechFunction",
            name: "speechFunction",
            component: () => import("@/views/admin/adminOperation/speechFunction/index.vue"),
            meta: {
              name: '发言功能设置',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // IP访问设置
          {
            path: "/admin/IPAccessSettings",
            name: "IPAccessSettings",
            component: () => import("@/views/admin/adminOperation/IPAccessSettings/index.vue"),
            meta: {
              name: 'IP访问设置',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 操作日志
          {
            path: "/admin/operationLog",
            name: "operationLog",
            component: () => import("@/views/admin/adminOperation/operationLog/index.vue"),
            meta: {
              name: '操作日志',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          },
          // 任务调度
          {
            path: '/admin/taskScheduling',
            name: 'taskScheduling',
            component: () => import("@/views/admin/adminOperation/taskScheduling/index.vue"),
            meta: {
              name: '任务调度',
              keepAlive: true,
              activeMenu: '/admin/operation',
              hidden: false,
            }
          }
        ]
      },
      // 资源管理
      {
        path: "/admin/resource",
        name: "adminResource",
        component: () => import("@/views/admin/adminResource/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'resource',
          hidden: false,
          name: '资源管理'
        },
        redirect: "/admin/typeManagement",
        children: [
          // 类型管理
          {
            path: "/admin/typeManagement",
            name: "typeManagement",
            component: () => import("@/views/admin/adminResource/typeManagement/index.vue"),
            meta: {
              name: '类型管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 课程管理
          {
            path: "/admin/courseManagement",
            name: "courseManagement",
            component: () => import("@/views/admin/adminResource/courseManagement/index.vue"),
            meta: {
              name: '课程管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 课程详情
          {
            path: "/admin/courseInfSet/:courseId",
            name: "courseInfSet",
            component: () => import("@/views/admin/adminResource/courseManagement/courseInfSet.vue"),
            meta: {
              name: '课程详情',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 添加内容
          {
            path: '/admin/addCourse/:courseId/:parentId',
            name: 'addCourse',
            component: () => import("@/views/admin/adminResource/courseManagement/addCourse.vue"),
            meta: {
              name: '添加内容',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: true,
            },

          },
          // 题库管理
          {
            path: "/admin/bankList",
            name: "bankList",
            component: () => import("@/views/admin/adminResource/bankManage/bankList.vue"),
            meta: {
              name: '题库管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 题库试题
          {
            path: "/admin/banktest/:QL_Id",
            name: "banktest",
            component: () => import("@/views/admin/adminResource/bankManage/banktest.vue"),
            meta: {
              name: '题库试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 查看试题
          {
            path: "/admin/seetest",
            name: "seetest",
            component: () => import("@/views/admin/adminResource/bankManage/seetest.vue"),
            meta: {
              name: '查看试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 添加单选试题
          {
            path: "/admin/addChoicetest",
            name: "addChoicetest",
            component: () => import("@/views/admin/adminResource/bankManage/addChoicetest.vue"),
            meta: {
              name: '编辑单选试题',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 添加多选试题
          {
            path: "/admin/addMultipletest",
            name: "addMultipletest",
            component: () => import("@/views/admin/adminResource/bankManage/addMultipletest.vue"),
            meta: {
              name: '添加多选试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 添加判断试题
          {
            path: "/admin/addJudgetest",
            name: "addJudgetest",
            component: () => import("@/views/admin/adminResource/bankManage/addJudgetest.vue"),
            meta: {
              name: '添加判断试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 添加填空试题
          {
            path: "/admin/addFilltest",
            name: "addFilltest",
            component: () => import("@/views/admin/adminResource/bankManage/addFilltest.vue"),
            meta: {
              name: '添加填空试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 添加问答试题
          {
            path: "/admin/addQAtest",
            name: "addQAtest",
            component: () => import("@/views/admin/adminResource/bankManage/addQAtest.vue"),
            meta: {
              name: '添加问答试题',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: true,
            }
          },
          // 试卷管理
          {
            path: "/admin/paperList",
            name: "paperList",
            component: () => import("@/views/admin/adminResource/paperManage/paperList.vue"),
            meta: {
              name: '试卷管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 试卷编辑-练习
          {
            path: "/admin/practicePaperEdit",
            name: "practicePaperEdit",
            component: () => import("@/views/admin/adminResource/paperManage/practicePaperEdit.vue"),
            meta: {
              name: '试卷编辑',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 试卷编辑-考核、模拟
          {
            path: "/admin/paperEdit",
            name: "paperEdit",
            component: () => import("@/views/admin/adminResource/paperManage/paperEdit.vue"),
            meta: {
              name: '试卷编辑',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 素材库管理
          {
            path: "/admin/materialLibraryManage",
            name: "materialLibraryManage",
            component: () => import("@/views/admin/adminResource/materialManage/materialLibraryManage.vue"),
            meta: {
              name: '素材库管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 素材管理
          {
            path: "/admin/materialManage/:smlibId",
            name: "materialManage",
            component: () => import("@/views/admin/adminResource/materialManage/materialManage.vue"),
            meta: {
              name: '素材管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 软件管理
          {
            path: "/admin/softwareManage",
            name: "softwareManage",
            component: () => import("@/views/admin/adminResource/softwareManage/softwareManage.vue"),
            meta: {
              name: '软件管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
          // 工况列表
          {
            path: "/admin/workCondition/:softwareId",
            name: "workCondition",
            component: () => import("@/views/admin/adminResource/softwareManage/workCondition.vue"),
            meta: {
              name: '工况列表',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 讲师管理
          {
            path: "/admin/LecturerManage",
            name: "LecturerManage",
            component: () => import("@/views/admin/adminResource/LecturerManage/LecturerManage.vue"),
            meta: {
              name: '讲师管理',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            }
          },
        ]
      },
      // 物理空间-超管
      {
        path: "/admin/physicalSpace",
        name: "physicalSpace",
        component: () => import("@/views/admin/adminPhysicalSpace/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'physicalSpace',
          hidden: false,
          name: '物理空间'
        },
        redirect: "/admin/physicalSpaceEnterpriseList",
        children:[
          // 企业列表
          {
            path: '/admin/physicalSpaceEnterpriseList',
            name: 'physicalSpaceEnterpriseList',
            component: () => import("@/views/admin/adminPhysicalSpace/physicalSpaceEnterpriseList/index.vue"),
            meta: {
              name: '企业列表',
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 项目管理
          {
            path: '/admin/projectManage/:belongingTo/:enterpriseName',
            name: 'projectManage',
            component: () => import("@/views/admin/adminPhysicalSpace/projectManage/index.vue"),
            meta: {
              name: '项目管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 区域管理
          {
            path: '/admin/regionManage/:belongingTo/:phySpaceId/:enterpriseName',
            name: 'regionManage',
            component: () => import("@/views/admin/adminPhysicalSpace/regionManage/index.vue"),
            meta: {
              name: '区域管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: true,
            },
          },
          // 设备管理
          {
            path: '/admin/deviceManage/:belongingTo/:phySpaceId/:PhyRegionId/:enterpriseName',
            name: 'deviceManage',
            component: () => import("@/views/admin/adminPhysicalSpace/regionManage/deviceManage.vue"),
            meta: {
              name: '设备管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 物资管理
          {
            path: '/admin/materialsManage/:belongingTo/:phySpaceId/:PhyRegionId/:enterpriseName',
            name: 'materialsManage',
            component: () => import("@/views/admin/adminPhysicalSpace/regionManage/materialsManage.vue"),
            meta: {
              name: '物资管理',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 门禁打卡记录
          {
            path: '/admin/accessControl/:phySpaceId',
            name: 'accessControl',
            component: () => import("@/views/admin/adminPhysicalSpace/projectManage/accessControl.vue"),
            meta: {
              name: '门禁打卡记录',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
          // 监控列表
          {
            path: '/admin/CameraList/:phySpaceId/:enterpriseName',
            name: 'CameraList',
            component: () => import("@/views/admin/adminPhysicalSpace/projectManage/CameraList.vue"),
            meta: {
              name: '监控列表',
              keepAlive: false,
              activeMenu: 'resource',
              hidden: false,
            },
          },
        ]
      },
      // 物理空间-企业管理员
      {
        path: '/admin/physicalSpaceEnterprise',
        name: 'physicalSpaceEnterprise',
        component: () => import("@/views/admin/adminPhysicalSpace/physicalSpaceEnterprise.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'physicalSpaceEnterprise',
          hidden: false,
          name: '物理空间'
        },
        redirect: "/admin/physicalSpace/dataStatistics",
        children:[
          // 物理空间-数据统计
          {
            path: '/admin/physicalSpace/dataStatistics',
            name: 'physicalSpaceDataStatistics',
            component: () => import("@/views/admin/adminPhysicalSpace/physicalSpaceDataStatistics/index.vue"),
            meta: {
              name: '数据概览',
              keepAlive: true,
              activeMenu: 'physicalSpaceEnterprise',
              hidden: false,
            },
          },
        ]
      },
      // 机构管理
      {
        path: '/admin/mechanism',
        name: "adminMechanism",
        component: () => import("@/views/admin/adminMechanism/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminMechanism',
          hidden: false,
          name: '机构管理'
        },
        redirect: "/admin/mechanismManagement",
        children: [
          // 机构管理
          {
            path: '/admin/mechanismManagement',
            name: "adminmechanismManagement",
            component: () => import("@/views/admin/adminMechanism/mechanismManagement/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
              name: '机构管理'
            },
          },
          // 机构数据统计
          {
            path: '/admin/mechanismData',
            name: "adminmechanismData",
            component: () => import("@/views/admin/adminMechanism/mechanismData/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminMechanism',
              hidden: false,
              name: '机构数据统计'
            },
          },
          // 机构审核
          {
            path: '/admin/mechanismReview',
            name: "mechanismReview",
            component: () => import("@/views/admin/adminMechanism/mechanismReview/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminMechanism',
              hidden: false,
              name: '机构入驻审核'
            },
          },
          // 企业管理
          {
            path: '/admin/enterpriseManagement',
            name: "adminenterpriseManagement",
            component: () => import("@/views/admin/adminMechanism/enterpriseManagement/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
              name: '企业管理'
            },
          },
          // 企业数据统计
          {
            path: '/admin/enterpriseData',
            name: "adminenterpriseData",
            component: () => import("@/views/admin/adminMechanism/enterpriseData/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminEnterprise',
              hidden: false,
              name: '企业数据统计'
            },
          },
          // 企业审核
          {
            path: '/admin/enterpriseReview',
            name: "adminenterpriseReview",
            component: () => import("@/views/admin/adminMechanism/enterpriseReview/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminEnterprise',
              hidden: false,
              name: '企业数据统计'
            },
          },
          // 企业信息
          {
            path: '/admin/enterpriseMessage',
            name: "adminenterpriseMessage",
            component: () => import("@/views/admin/adminMechanism/enterpriseMessage/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminMechanism',
              hidden: false,
              name: '企业信息'
            },
          }
        ]
      },
      // 平台运营
      {
        path: '/admin/business',
        name: "adminBusiness",
        component: () => import("@/views/admin/adminBusiness/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminBusiness',
          hidden: false,
          name: '平台运营'
        },
        redirect: "/admin/courseBusiness",
        children: [
          // 课程运营
          {
            path: '/admin/courseBusiness',
            name: "admincourseBusiness",
            component: () => import("@/views/admin/adminBusiness/courseBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '平台课程运营'
            },
          },
          // 题库运营
          {
            path: '/admin/bankBusiness',
            name: "adminbankBusiness",
            component: () => import("@/views/admin/adminBusiness/bankBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '平台题库运营'
            },
          },
          // 素材库运营
          {
            path: '/admin/resBankBusiness',
            name: "resBankBusiness",
            component: () => import("@/views/admin/adminBusiness/resBankBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '平台素材库运营'
            },
          },
          // 软件运营
          {
            path: '/admin/softWareiness',
            name: "softWareiness",
            component: () => import("@/views/admin/adminBusiness/softWareiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '平台软件运营'
            },
          },
          // 用户课程运营
          {
            path: '/admin/userCourseBusiness',
            name: "userCourseBusiness",
            component: () => import("@/views/admin/adminBusiness/userCourseBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '用户课程运营'
            },
          },
          // 用户题库运营
          {
            path: '/admin/userBankBusiness',
            name: "userBankBusiness",
            component: () => import("@/views/admin/adminBusiness/userBankBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '用户题库运营'
            },
          },
          // 用户素材库运营
          {
            path: '/admin/userResBankBusiness',
            name: "userResBankBusiness",
            component: () => import("@/views/admin/adminBusiness/userResBankBusiness/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '用户素材库运营'
            },
          },
          // 订单管理
          {
            path: '/admin/orderManagement',
            name: "orderManagement",
            component: () => import("@/views/admin/adminBusiness/orderManagement/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '订单管理'
            },
          },
          // 公告管理
          {
            path: '/admin/advertisement',
            name: "advertisement",
            component: () => import("@/views/admin/adminBusiness/advertisement/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '公告管理'
            },
          },
          // 新闻管理
          {
            path: '/admin/news',
            name: "news",
            component: () => import("@/views/admin/adminBusiness/news/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminBusiness',
              hidden: false,
              name: '新闻管理'
            },
          },
        ]
      },
      // 企业管理
      {
        path: '/admin/company',
        name: "adminCompany",
        component: () => import("@/views/admin/adminCompany/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminCompany',
          hidden: false,
          name: '企业管理'
        },
        redirect: "/admin/courseBusiness",
        children: [
          // 数据统计
          {
            path: '/admin/companyStatistics',
            name: "admincompanyStatistics",
            component: () => import("@/views/admin/adminCompany/companyStatistics/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '数据统计'
            },
          },
          // 企业信息
          {
            path: '/admin/companyInf',
            name: "admincompanyInf",
            component: () => import("@/views/admin/adminCompany/companyInf/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '企业信息'
            },
          },
          // 组织架构
          {
            path: '/admin/companystructure',
            name: "companystructure",
            component: () => import("@/views/admin/adminCompany/companystructure/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '组织架构'
            },
          },
          // 岗位职务
          {
            path: '/admin/companyjobTitle',
            name: "companyjobTitle",
            component: () => import("@/views/admin/adminCompany/companyjobTitle/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '岗位职务'
            },
          },
          // 企业学员
          {
            path: '/admin/enterpriseStudent',
            name: "enterpriseStudent",
            component: () => import("@/views/admin/adminCompany/enterpriseStudent/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '企业学员'
            },
          },
          // 学员审核
          {
            path: '/admin/studentReview',
            name: "studentReview",
            component: () => import("@/views/admin/adminCompany/studentReview/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '学员审核'
            },
          },
          // 培训计划
          {
            path: '/admin/trainingPlan',
            name: "trainingPlan",
            component: () => import("@/views/admin/adminCompany/trainingPlan/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '培训计划'
            },
          },
          // 培训计划-查询学员
          {
            path: '/admin/trainingPlan/planstudents/:PlanId',
            name: "planstudents",
            component: () => import("@/views/admin/adminCompany/trainingPlan/planStudents/studentList.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '查看学员'
            },
          },
          // 培训计划-查询课程
          {
            path: '/admin/trainingPlan/plancourse/:PlanId',
            name: "plancourse",
            component: () => import("@/views/admin/adminCompany/trainingPlan/plancourse/courseList.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '培训计划-课程详情'
            },
          },
          // 培训计划-查询试卷
          {
            path: '/admin/trainingPlan/planpaper/:PlanId',
            name: "planpaper",
            component: () => import("@/views/admin/adminCompany/trainingPlan/planpaper/paperList.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '培训计划-试卷详情'
            },
          },
          // 培训计划-查询区域设备
          {
            path: '/admin/trainingPlan/planPhysicalSpace/:PlanId',
            name: "planPhysicalSpace",
            component: () => import("@/views/admin/adminCompany/trainingPlan/planPhysicalSpace/regionList.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '培训计划-查询区域设备'
            },
          },
          // 网上答疑
          {
            path: '/admin/onlineQA',
            name: "onlineQA",
            component: () => import("@/views/admin/adminCompany/onlineQA/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '网上答疑'
            },
          },
          // 培训教师
          {
            path: '/admin/trainingTeachers',
            name: "trainingTeachers",
            component: () => import("@/views/admin/adminCompany/trainingTeachers/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminCompany',
              hidden: false,
              name: '培训教师'
            },
          },
          // 企业园
          // {
          //   path: '/admin/enterprisePark',
          //   name: "enterprisePark",
          //   component: () => import("@/views/admin/adminCompany/enterprisePark/index.vue"),
          //   meta: {
          //     keepAlive: true,
          //     activeMenu: 'adminCompany',
          //     hidden: false,
          //     name: '企业园'
          //   },
          // },
        ]
      },
      // 用户管理
      {
        path: '/admin/userManage',
        name: "adminUserManage",
        component: () => import("@/views/admin/adminUserManage/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminUserManage',
          hidden: false,
          name: '用户管理'
        },
        redirect: "/admin/courseBusiness",
        children: [
          // 数据统计
          {
            path: '/admin/userStatistics',
            name: 'userStatistics',
            component: () => import("@/views/admin/adminUserManage/userStatistics/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '数据统计'
            },
          },
          // 普通学员
          {
            path: '/admin/ordinaryStudents',
            name: 'ordinaryStudents',
            component: () => import("@/views/admin/adminUserManage/ordinaryStudents/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '普通学员'
            },
            children: [
            ]
          },
          // 企业学员
          {
            path: '/admin/enterpriseStudents',
            name: 'enterpriseStudents',
            component: () => import("@/views/admin/adminUserManage/enterpriseStudents/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '企业学员'
            },
          },
          // 培训教师
          {
            path: '/admin/allTeacher',
            name: 'allTeacher',
            component: () => import("@/views/admin/adminUserManage/allTeacher/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '培训教师'
            },
          },
          // 企业管理员
          {
            path: '/admin/enterpriseAdministrator',
            name: 'enterpriseAdministrator',
            component: () => import("@/views/admin/adminUserManage/enterpriseAdministrator/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '企业管理员'
            },
          },
          // 机构管理员
          {
            path: '/admin/organizationAdministrator',
            name: 'organizationAdministrator',
            component: () => import("@/views/admin/adminUserManage/organizationAdministrator/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminUserManage',
              hidden: false,
              name: '机构管理员'
            },
          },

        ]
      },
      // 积分任务
      {
        path: '/admin/pointsTask',
        name: "adminpointsTask",
        component: () => import("@/views/admin/adminpointsTask/index.vue"),
        meta: {
          keepAlive: true,
          activeMenu: 'adminpointsTask',
          hidden: false,
          name: '积分任务'
        },
        redirect: "/admin/dailyDetailManagement",
        children: [
          // 每日一练
          {
            path: '/admin/dailyDetailManagement',
            name: 'admindailyDetailManagement',
            component: () => import("@/views/admin/adminpointsTask/dailyDetailManagement/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'resource',
              hidden: false,
              name: '每日一练'
            },
          },
          // 每周一课
          {
            path: '/admin/weekClass',
            name: 'adminweekClass',
            component: () => import("@/views/admin/adminpointsTask/weekClass/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminpointsTask',
              hidden: false,
              name: '每周一课'
            },
          },
          // 每月一考
          {
            path: '/admin/monthExam',
            name: 'adminmonthExam',
            component: () => import("@/views/admin/adminpointsTask/monthExam/index.vue"),
            meta: {
              keepAlive: true,
              activeMenu: 'adminpointsTask',
              hidden: false,
              name: '每月一考'
            },
          },
        ]
      }
    ]
  },
  // 企业大数据
  {
    path: "/EnterpriseBigData",
    name: "EnterpriseBigData",
    component: () => import("@/views/admin/EnterpriseBigData/index.vue"),
    meta: {
      keepAlive: false,
    },
    children: [
      // 折线图
      {
        path: "/admin/stackLine",
        name: "adminStackLine",
        component: () => import("@/views/admin/EnterpriseBigData/components/adminStackLine/index.vue"),
        meta: {
          name: '折线图',
          keepAlive: true,
          activeMenu: '/admin/stackLine',
          hidden: false,
        }
      },
      // 曲线折线图
      {
        path: "/admin/curveStackLine",
        name: "adminCurveStackLine",
        component: () => import("@/views/admin/EnterpriseBigData/components/adminCurveStackLine/index.vue"),
        meta: {
          name: '曲线折线图',
          keepAlive: true,
          activeMenu: '/admin/curveStackLine',
          hidden: false,
        }
      },
      // 折线图2
      {
        path: "/admin/stackLineTwo",
        name: "adminStackLineTwo",
        component: () => import("@/views/admin/EnterpriseBigData/components/adminStackLineTwo/index.vue"),
        meta: {
          name: '折线图2',
          keepAlive: true,
          activeMenu: '/admin/stackLineTwo',
          hidden: false,
        }
      },
      // 柱状图
      {
        path: "/admin/barChart",
        name: "adminBarChart",
        component: () => import("@/views/admin/EnterpriseBigData/components/adminBarChart/index.vue"),
        meta: {
          name: '折线图2',
          keepAlive: true,
          activeMenu: '/admin/barChart',
          hidden: false,
        }
      },
    ]
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
    // meta:{requiresAuth:true}
  },
  // 测试页
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue"),
    // meta:{requiresAuth:true}
  },
  // 错误页面404
  {
    component: () => import("@/views/error/Error.vue"),
    path: "*",
  },
];
const router = new VueRouter({
  routes,
  mode: "hash",
});
// 路由切换检查权限
router.beforeEach((to, from, next) => {
  // 检查当前设备是否手机端
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 需要登录授权，这里还需要判断是否登录
    const Token = sessionStorage.getItem("Token");
    if (Token) {
      next();
    } else {
      next("/"); // 跳转到登录
      this.$message.warning("登录过期，请重新登录")
    }
  } else {
    next();
  }
});
// 模拟切换页面时,跳转到页面顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;